import React, { useState, useEffect, useCallback } from "react";
import Sidebar from "../../../layout/Sidebar";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import { can } from "../../../utils/can";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CMSFaqManager from "../../../components/common/CMSFaqManager";

const PAGE_TYPE = "home_page";

export default function CMSHomePage() {
  const API_URL = (process.env.REACT_APP_BASE_URL_API || "").replace(/\/$/, "");
  const token = localStorage.getItem("adminToken");

  const [form, setForm] = useState({
    id: null,
    aboutTitle1: "",
    aboutTitle2: "",
    content: "",
    whyChooseTitle: "",
    whyChooseUs: "",
    sectionTitle: "",
    sectionContent: "",
    faqTitle: "",
    faqs: [],
    metaTitle: "",
    metaKeywords: "",
    customScript: "",
    metaDescription: "",
  });
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    try {
      const res = await fetch(
        `${API_URL}/api/admin/cms-page-list?pageType=${PAGE_TYPE}&limit=1`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const result = await res.json();
      if (result.success && result.data?.length) {
        const d = result.data[0];
        setForm({
          id: d._id,
          aboutTitle1: d.aboutTitle1 || "",
          aboutTitle2: d.aboutTitle2 || "",
          content: d.content || "",
          whyChooseTitle: d.whyChooseTitle || "",
          whyChooseUs: d.whyChooseUs || "",
          sectionTitle: d.sectionTitle || "",
          sectionContent: d.sectionContent || "",
          faqTitle: d.faqTitle || "",
          faqs: Array.isArray(d.faqs) ? d.faqs : [],
          metaTitle: d.metaTitle || "",
          metaKeywords: d.metaKeywords || "",
          customScript: d.customScript || "",
          metaDescription: d.metaDescription || "",
        });
      }
    } catch (err) {
      console.error(err);
    }
  }, [API_URL, token]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (can("cms_home_page", form.id ? "edit" : "create") === false) {
      alert("You don't have permission.");
      return;
    }
    setLoading(true);
    setMessage("");

    const url = form.id
      ? `${API_URL}/api/admin/cms-page-list/update/${form.id}`
      : `${API_URL}/api/admin/cms-page-create`;

    try {
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          pageType: PAGE_TYPE,
          aboutTitle1: form.aboutTitle1,
          aboutTitle2: form.aboutTitle2,
          content: form.content,
          whyChooseTitle: form.whyChooseTitle,
          whyChooseUs: form.whyChooseUs,
          sectionTitle: form.sectionTitle,
          sectionContent: form.sectionContent,
          faqTitle: form.faqTitle,
          faqs: form.faqs,
          metaTitle: form.metaTitle,
          metaKeywords: form.metaKeywords,
          customScript: form.customScript,
          metaDescription: form.metaDescription,
        }),
      });
      const result = await res.json();
      if (result.success) {
        setMessage("Saved successfully!");
        if (result.data?._id) setForm((p) => ({ ...p, id: result.data._id }));
      } else {
        alert(result.message || "Something went wrong.");
      }
    } catch (err) {
      console.error(err);
      alert("Server error.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container body">
      <div className="main_container">
        <Sidebar />
        <Header pageTitle="CMS - Home Page" />
        <div className="right_col" role="main">
          <div className="x_panel">
            <div className="x_title">
              <h2>Home Page Content</h2>
              <div className="clearfix" />
            </div>
            <div className="x_content">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-12 col-sm-6 mb-3">
                    <label>About Title 1</label>
                    <input type="text" className="form-control" value={form.aboutTitle1}
                      onChange={(e) => setForm({ ...form, aboutTitle1: e.target.value })} />
                  </div>
                  <div className="col-12 col-sm-6 mb-3">
                    <label>About Title 2</label>
                    <input type="text" className="form-control" value={form.aboutTitle2}
                      onChange={(e) => setForm({ ...form, aboutTitle2: e.target.value })} />
                  </div>
                  <div className="col-12 mb-3">
                    <label>Content</label>
                    <CKEditor editor={ClassicEditor} data={form.content}
                      onChange={(_, editor) => setForm((p) => ({ ...p, content: editor.getData() }))} />
                  </div>
                  <div className="col-12 col-sm-6 mb-3">
                    <label>Why Choose Title / Heading (Optional)</label>
                    <input type="text" className="form-control" value={form.whyChooseTitle}
                      onChange={(e) => setForm({ ...form, whyChooseTitle: e.target.value })} placeholder="e.g. Best Marriage Bureau in India" />
                  </div>
                  <div className="col-12 mb-3">
                    <label>Why Choose Us Content</label>
                    <CKEditor editor={ClassicEditor} data={form.whyChooseUs}
                      onChange={(_, editor) => setForm((p) => ({ ...p, whyChooseUs: editor.getData() }))} />
                  </div>
                  <div className="col-12 col-sm-6 mb-3">
                    <label>Section 3 Title / Bottom Heading (Optional)</label>
                    <input type="text" className="form-control" value={form.sectionTitle}
                      onChange={(e) => setForm({ ...form, sectionTitle: e.target.value })} placeholder="e.g. Best Matrimonial Services in India" />
                  </div>
                  <div className="col-12 mb-3">
                    <label>Section 3 Content / Bottom Content (Optional)</label>
                    <CKEditor editor={ClassicEditor} data={form.sectionContent}
                      onChange={(_, editor) => setForm((p) => ({ ...p, sectionContent: editor.getData() }))} />
                  </div>

                  <CMSFaqManager
                    faqTitle={form.faqTitle}
                    onChangeFaqTitle={(faqTitle) => setForm((p) => ({ ...p, faqTitle }))}
                    faqs={form.faqs}
                    onChangeFaqs={(faqs) => setForm((p) => ({ ...p, faqs }))}
                  />

                  <div className="col-md-12 mb-3">
                    <label>Meta Title</label>
                    <input type="text" className="form-control" value={form.metaTitle}
                      onChange={(e) => setForm({ ...form, metaTitle: e.target.value })} />
                  </div>
                  <div className="col-md-12 mb-3">
                    <label>Meta Keywords</label>
                    <input type="text" className="form-control" value={form.metaKeywords}
                      onChange={(e) => setForm({ ...form, metaKeywords: e.target.value })} />
                  </div>
                  <div className="col-md-12 mb-3">
                    <label>Custom Scripts (GTM, Schema, Analytics)</label>
                    <textarea
                      className="form-control"
                      rows={4}
                      placeholder="<script type=&quot;application/ld+json&quot;>&#10;...&#10;</script>"
                      value={form.customScript}
                      onChange={(e) => setForm({ ...form, customScript: e.target.value })}
                    />
                  </div>
                  <div className="col-md-12 mb-3">
                    <label>Meta Description</label>
                    <textarea className="form-control" rows={2} value={form.metaDescription}
                      onChange={(e) => setForm({ ...form, metaDescription: e.target.value })} />
                  </div>
                  <div className="col-12 text-right">
                    <button type="submit" className="btn sitebtn" disabled={loading}>
                      {loading ? "Saving..." : "Save"}
                    </button>
                    {message && <div className="text-success mt-2">{message}</div>}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
